// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2Stfl","left":"InfoRow_left__1VlGr"};